import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import WorkRecordApi from "../../api/workRecordApi";
import WorkRecordDetailView from "../../components/workrecord/WorkRecordDetailView";
import { ArrowLeft } from "lucide-react";

function GetWorkRecordPage() {
  const { workRecordId } = useParams();
  const navigate = useNavigate();
  const [wr, setWr] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    WorkRecordApi.get(workRecordId)
      .then((res) => {
        setWr(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [workRecordId]);

  if (loading) {
    return (
      <div className="h-screen flex justify-center items-center bg-gradient-to-b from-blue-50 to-white">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-[rgb(0,224,198)] border-t-transparent"></div>
          <p className="text-sm text-gray-500 font-medium">불러오는 중...</p>
        </div>
      </div>
    );
  }

  if (!wr) {
    return (
      <div className="h-screen flex justify-center items-center bg-gradient-to-b from-blue-50 to-white">
        <div className="text-center">
          <div className="text-6xl mb-4">📊</div>
          <p className="text-gray-600 font-semibold">
            운동 기록을 찾을 수 없습니다
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden bg-gradient-to-b from-blue-50 to-white flex flex-col">
      {/* HEADER - 상단 고정 */}
      <header className="bg-white px-5 py-4 border-b border-gray-200 shadow-sm">
        <div className="flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
          <h1 className="text-2xl font-bold text-gray-800">운동 기록</h1>
          <div className="w-10"></div>
        </div>
      </header>

      {/* 상세 뷰 - 스크롤 영역 */}
      <main className="flex-1 overflow-y-auto">
        <WorkRecordDetailView wr={wr} />
      </main>
    </div>
  );
}

export default GetWorkRecordPage;
